import * as types from "../../../redux/actionTypes";
import initialState from "../../../redux/initialState";

export default function kbArticle(state = initialState.kbArticle, action) {
  switch (action.type) {
    case types.LOAD_KB_ARTICLE_BEGIN:
      return {
        ...state,
        loading: true,
        error: null,
        record: null
      };

    case types.LOAD_KB_ARTICLE_SUCCESS:
      return {
        ...state,
        loading: false,
        error: null,
        articleNumber: action.articleNumber,
        record: action.article,
        notFound: !action.article
      };

    case types.LOAD_KB_ARTICLE_ERROR:
      return {
        ...state,
        loading: false,
        error: `An error occurred while loading the knowledge article: ${action.errorMessage}`,
        record: null
      };

    default:
      return state;
  }
}
